// src/pages/TermsOfUse.js

import React from "react";
import "./TermsOfUse.css";

const TermsOfUse = () => {
  return (
    <div className="terms-container">
      <div className="terms-content">
        <h1>Terms of Use</h1>
        <p className="effective-date">Effective Date: July 31, 2025</p>

        <h2>1. Use of Content</h2>
        <p>
          All content provided is for informational purposes only. We do not
          guarantee investment returns or offer financial advice.
        </p>

        <h2>2. Intellectual Property</h2>
        <p>
          All logos, brand names, text, graphics, and other content are the
          property of stockvia.in unless otherwise stated.
        </p>

        <h2>3. Disclaimer</h2>
        <p>
          We make no warranties about the accuracy, reliability, or availability
          of the website and its content.
        </p>

        <h2>4. Limitation of Liability</h2>
        <p>
          We are not liable for any losses or damages resulting from the use of
          this site or reliance on its content.
        </p>

        <h2>5. External Links</h2>
        <p>
          Our site may link to third-party websites. We are not responsible for
          the content or privacy practices of those sites.
        </p>

        <h2>6. Changes to Terms</h2>
        <p>
          We may update these terms at any time. Continued use of the site means
          you accept the updated terms.
        </p>

        <h2>7. Contact Us</h2>
        <p>
          For any questions, contact us at: <br />
          <a href="mailto:your-email@stockvia.in">your-email@stockvia.in</a>
        </p>
      </div>
    </div>
  );
};

export default TermsOfUse;
